import dayjs from "dayjs";
import { GENDER_MALE } from "../constants";

const getCheckBoxText = (
  nauticalPdColor,
  reason_for_copy_nautical_issue,
  sintaksiouxos_afora
) => {
  let finalText = `<h4 style="margin-top:0.5rem">Δηλώνω υπεύθυνα ότι:</h4>`;

  if (nauticalPdColor === "KOKKINO") {
    const notRetiredRedText = `
    <h4 style="margin-top:0.5rem>Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση Ναυτικού Φυλλαδίου
      σύμφωνα με τις προϋποθέσεις του π.δ. 260/2001. Με ατομική μου ευθύνη και γνωρίζοντας τις κυρώσεις,
      που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου 22 του Ν. 1599/1986, σας δηλώνω υπεύθυνα ότι:
    </h4>

    <h4 style="margin-top:0.5rem">
      Δεν έχω καταδικαστεί αμετάκλητα για λιποταξία ή ανυποταξία.
    </h4>

    <h4 style="margin-top:0.5rem">
      Δεν έχω εφοδιαστεί κατά το παρελθόν με άλλο ναυτικό φυλλάδιο και γνωρίζω κολύμβηση.
    </h4>

    <h4 style="margin-top:0.5rem">Δεν έχω την ιδιότητα του εν ενεργεία ή συνταξιούχου πολιτικού ή
      στρατιωτικού δημοσίου υπαλλήλου, υπαλλήλου νομικού προσώπου δημοσίου
      δικαίου ή κοινωνικοποιημένου οργανισμού και δεν είμαι συνταξιούχος ως
      άνω φορέων(π.δ. 260 / 2001, όπως ισχύει).
    </h4>
    `;

    finalText += notRetiredRedText;
  }

  const retiredBlueText = `<h4 style="margin-top:0.5rem">Είμαι συνταξιούχος  φορέα ενταχθέντος στον Ενιαίο Φορέα Κοινωνικής  Ασφάλισης (Ε.Φ.Κ.Α.) ή έτερου δημοσίου ασφαλιστικού φορέα (π.δ. 104/2020).</h4>`;

  const notRetiredBlueText = `<h4 style="margin-top:0.5rem">Δεν είμαι συνταξιούχος  φορέα ενταχθέντος στον Ενιαίο Φορέα Κοινωνικής  Ασφάλισης (Ε.Φ.Κ.Α.) ή έτερου δημοσίου ασφαλιστικού φορέα (π.δ.104/2020).</h4>`;

  const isRetiredText =
    sintaksiouxos_afora == "2" ? notRetiredBlueText : retiredBlueText;

  if (nauticalPdColor === "ΜΠΛΕ" && !reason_for_copy_nautical_issue) {
    finalText += isRetiredText;
  }

  let reasonForCopyText = "";

  switch (reason_for_copy_nautical_issue) {
    case 1:
      reasonForCopyText = `<h4 style="margin-top:0.5rem">Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω κλοπής - απώλειας.</h4>`;
      break;
    case 2:
      reasonForCopyText = `<h4 style="margin-top:0.5rem">Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω συμπλήρωσης ή φθοράς.</h4>`;
      break;
    case 3:
      reasonForCopyText = `<h4 style="margin-top:0.5rem">Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην έκδοση αντιγράφου ναυτικού φυλλαδίου λόγω αλλαγής ναυτικού φυλλαδίου από περιορισμένης χρήσης σε όλους τους κλάδους και αντίθετα.</h4>`;
      break;
    default:
      break;
  }

  finalText += reasonForCopyText;

  return `<p>${finalText}</p>`;
};

export const sinoptikoEktipotiko = (
  data,
  birthPlace,
  applicationFinishedDate
) => {
  let nauticalPdColor;
  const birthDate = dayjs(data.dt_birth_afora).format("DD/MM/YYYY");
  data?.nautical_pd_color === "red"
    ? (nauticalPdColor = "KOKKINO")
    : (nauticalPdColor = "ΜΠΛΕ");

  return `
      <div style="display:flex;align-items:center;justify-content:center;flex-direction:column;">
        <h2 style="text-decoration:underline;text-align:center;">ΕΦΑΡΜΟΓΗ E-ΘΥΡΙΔΑ</h2>
        <h2 style="text-decoration:underline;text-align:center;">
          ΣΥΝΟΠΤΙΚΟ ΕΚΤΥΠΩΤΙΚΟ ΑΙΤΗΣΕΩΝ - YΔ
        </h2>
        <h3 style="text-decoration:underline;text-align:center;">
          ΑΠΟΤΥΠΩΣΗ ΒΑΣΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΑΙΤΗΣΗΣ/ΓΡΑΜΜΗΣ
        </h3>
      </div>
      <div style="margin-left:2rem">
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΗΜΕΡΟΜΗΝΙΑ (ΟΛΟΚΛΗΡΩΣΗΣ ΑΙΤΗΣΗΣ):&nbsp;${applicationFinishedDate}</h4>
          </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΜΟΝΑΔΙΚΟΣ ΑΡΙΘΜΟΣ ΑΙΤΗΣΗΣ:&nbsp;${
            data.reg_num
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΑΠΟΓΡΑΦΟΥΣΑ ΑΡΧΗ:&nbsp;${
            data.portAuthority
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΕΙΔΟΣ ΑΙΤΗΣΗΣ:&nbsp;${
            data.applicationKind
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΧΡΩΜΑ ΦΥΛΛΑΔΙΟΥ (ΜΠΛΕ/ΚΟΚΚΙΝΟ):&nbsp;${
            nauticalPdColor === "ΜΠΛΕ"
              ? "ΜΠΛΕ ΠΔ 104/2020"
              : "ΚΟΚΚΙΝΟ ΠΔ 260/2001"
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΟΝΟΜΑΤΕΠΩΝΥΜΟ ΝΑΥΤΙΚΟΥ:&nbsp;${
            data.fname_afora
          }&nbsp;${data.lname_afora}</h4>
         
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΟΝΟΜΑ ΠΑΤΡΟΣ:&nbsp;${
            data.fath_fname_afora
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΟΝΟΜΑ ΜΗΤΡΟΣ:&nbsp;${
            data.moth_fname_afora
          }</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΚΛΑΔΟΣ:&nbsp;${data?.sector || ""}</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΜΕΘ:&nbsp;${data?.meth_afora}</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΑΜΚΑ:&nbsp;${data?.amka_afora}</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΑΦΜ:&nbsp;${data?.afm_afora}</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΕΤΟΣ ΓΕΝΝΗΣΗΣ:&nbsp;${birthDate}</h4>
        </div>
        <div style="display:flex;align-items:center;">
          <h4 style="margin-top:0.5rem">ΤΟΠΟΣ ΓΕΝΝΗΣΗΣ:&nbsp;${birthPlace}</h4>
        </div>
        ${getCheckBoxText(
          nauticalPdColor,
          data.reason_for_copy_nautical_issue,
          data.sintaksiouxos_afora
        )}
      </div>
    `;
};

export const ektipotikoAitisis = (
  data,
  birthPlace,
  applicationFinishedDate
) => {
  let nauticalPdColor;
  const birthDate = dayjs(data.dt_birth_afora).format("DD/MM/YYYY");
  data?.nautical_pd_color === "red"
    ? (nauticalPdColor = "KOKKINO")
    : (nauticalPdColor = "ΜΠΛΕ");

  const mitrooBirthDate = data.mitroo_dt_birth
    ? dayjs(data.mitroo_dt_birth).format("DD/MM/YYYY")
    : "";

  return `
  <h2 style="text-decoration:underline;text-align:center;">ΕΦΑΡΜΟΓΗ  Ε-ΘΥΡΙΔΑ</h2>
<h2 style="text-decoration:underline;text-align:center;">ΕΚΤΥΠΩΤΙΚΟ ΑΙΤΗΣΗΣ - ΥΔ</h2>
<h4 style="text-decoration:underline;">ΚΕΝΤΡΙΚΑ ΣΤΟΙΧΕΙΑ</h4>
<p style="margin-top:0.25rem">ΗΜΕΡΟΜΗΝΙΑ (ΟΛΟΚΛΗΡΩΣΗΣ ΑΙΤΗΣΗΣ):&nbsp;${applicationFinishedDate}</p>
<p style="margin-top:0.25rem">ΜΟΝΑΔΙΚΟΣ ΑΡΙΘΜΟΣ ΑΙΤΗΣΗΣ:&nbsp;${
    data.reg_num
  }</p>
<p style="margin-top:0.25rem">ΑΠΟΓΡΑΦΟΥΣΑ ΑΡΧΗ:&nbsp;${data.portAuthority}</p>
<p style="margin-top:0.25rem">ΕΙΔΟΣ ΑΙΤΗΣΗΣ:&nbsp;${data.applicationKind}</p>
<p style="margin-top:0.25rem">ΧΡΩΜΑ ΦΥΛΛΑΔΙΟΥ (ΜΠΛΕ/ΚΟΚΚΙΝΟ):&nbsp;${
    nauticalPdColor === "ΜΠΛΕ" ? "ΜΠΛΕ ΠΔ 104/2020" : "ΚΟΚΚΙΝΟ ΠΔ 260/2001"
  }</p>
<h4 style="text-decoration:underline;margin-top:2rem;">ΣΤΟΙΧΕΙΑ ΝΑΥΤΙΚΟΥ</h4>
<p style="margin-top:0.25rem">ΕΠΩΝΥΜΟ:&nbsp;${data.lname_afora}</p>
<p style="margin-top:0.25rem">ΟΝΟΜΑ:&nbsp;${data.fname_afora}</p>
<p style="margin-top:0.25rem">ΦΥΛΟ:&nbsp;${
    data.gender_afora === GENDER_MALE ? "ΑΡΡΕΝ" : "ΘΗΛΥ"
  }</p>
<p style="margin-top:0.25rem">ΟΝΟΜΑΤΕΠΩΝΥΜΟ ΠΑΤΡΟΣ:&nbsp;${
    data.fath_fname_afora
  }&nbsp;${data.fath_lname_afora}</p>
<p style="margin-top:0.25rem">ΟΝΟΜΑΤΕΠΩΝΥΜΟ ΜΗΤΡΟΣ:&nbsp;${
    data.moth_fname_afora
  }&nbsp;${data.moth_lname_afora}</p>
<p style="margin-top:0.25rem">ΚΛΑΔΟΣ:&nbsp;${data?.sector || ""}</p>
<p style="margin-top:0.25rem">ΜΕΘ:&nbsp;${data?.meth_afora}</p>
<p style="margin-top:0.25rem">ΑΜΚΑ:&nbsp;${data?.amka_afora}</p>
<p style="margin-top:0.25rem">ΑΦΜ:&nbsp;${data?.afm_afora}</p>
<p style="margin-top:0.25rem">ΔΙΕΥΘΥΝΣΗ ΚΑΤΟΙΚΙΑΣ:&nbsp;${
    data?.address_nr_afora
  }</p>
<p style="margin-top:0.25rem">ΤΚ:&nbsp;${data?.tk_afora}</p>
<p style="margin-top:0.25rem">ΤΗΛΕΦΩΝΟ 1:&nbsp;${data?.tel_afora}</p>
<p style="margin-top:0.25rem">ΤΗΛΕΦΩΝΟ 2:&nbsp;${data?.mobile_afora}</p>
<p style="margin-top:0.25rem">Email:&nbsp;${data?.email_afora}</p>
<p style="margin-top:0.25rem">ΥΠΗΚΟΟΤΗΤΑ:&nbsp;${data?.nationality_afora}</p>
<p style="margin-top:0.25rem">ΑΡΙΘΜΟΣ ΤΑΥΤΟΤΗΤΑΣ:&nbsp;${data?.ind_nr_afora}</p>
<p style="margin-top:0.25rem">ΗΜΕΡΟΜΗΝΙΑ ΓΕΝΝΗΣΗΣ:&nbsp;${birthDate}</p>
<p style="margin-top:0.25rem">ΤΟΠΟΣ ΓΕΝΝΗΣΗΣ:&nbsp;${birthPlace}</p>
<h4 style="text-decoration:underline;">ΜΗΤΡΩΟ ΠΟΛΙΤΩΝ</h4>
<p style="margin-top:0.25rem">Όνομα:&nbsp;${data.mitroo_fname || ""}</p>
<p style="margin-top:0.25rem">Επώνυμο:&nbsp;${data.mitroo_lname || ""}</p>
<p style="margin-top:0.25rem">Φύλο:&nbsp;${data.mitroo_gender || ""}</p>
<p style="margin-top:0.25rem">Όνομα μητρός:&nbsp;${
    data.mitroo_moth_fname || ""
  }</p>
<p style="margin-top:0.25rem">Επώνυμο μητρός:&nbsp;${
    data.mitroo_moth_lname || ""
  }</p>
<p style="margin-top:0.25rem">Όνομα πατρός:&nbsp;${
    data.mitroo_fath_fname || ""
  }</p>
<p style="margin-top:0.25rem">Επώνυμο πατρός:&nbsp;${
    data.mitroo_fath_lname || ""
  }</p>
<p style="margin-top:0.25rem">Αριθμός ταυτότητας:&nbsp;${
    data.mitroo_ind_nr || ""
  }</p>
<p style="margin-top:0.25rem">Δήμος:&nbsp;${
    data.mitroo_municipalityName || ""
  }</p>
<p style="margin-top:0.25rem">Μερίδα:&nbsp;${data.mitroo_merida || ""}</p>
<p style="margin-top:0.25rem">Μέλος:&nbsp;${data.mitroo_member || ""}</p>
<p style="margin-top:0.25rem">Τόπος γέννησης:&nbsp;${
    data.mitroo_place_birth || ""
  }</p>
<p style="margin-top:0.25rem">Πόλη εξωτερικού:&nbsp;${
    data.mitroo_birthForeignCity || ""
  }</p>
<p style="margin-top:0.25rem">Εθνικότητα:&nbsp;${
    data.mitroo_nationality || ""
  }</p>
<p style="margin-top:0.25rem">Λιμενική αρχή:&nbsp;${
    data.mitroo_port_auth || ""
  }</p>

<p style="margin-top:0.25rem">Ημερομηνία γέννησης:&nbsp;${
    mitrooBirthDate || ""
  }</p>
<p style="margin-top:0.25rem">ΤΚ:&nbsp;${data.mitroo_tk || ""}</p>
<p style="margin-top:0.25rem">Αριθμός διεύθυνσης:&nbsp;${
    data.mitroo_address_nr || ""
  }</p>
<p style="margin-top:0.25rem">Διεύθυνση:&nbsp;${data.mitroo_address || ""}</p>
${getCheckBoxText(
  nauticalPdColor,
  data.reason_for_copy_nautical_issue,
  data.sintaksiouxos_afora
)}
  `;
};
